// extracted by mini-css-extract-plugin
export var audioPlayer = "_qz-0";